<template>
  <v-tooltip left>
    <template v-slot:activator="{ on }">
      <v-icon
        v-on="on"
        size="11"
        class="hyp-admin-info pull-left ml-3"
        :class="className"
        @click.stop.prevent="handleClick"
        >far fa-comment-dots</v-icon
      >
    </template>
    <span v-html="text"></span>
  </v-tooltip>
</template>

<script>
const EMITTED_ACTIONS = {
  CLICK: "click",
};

export default {
  name: "PopupInfo",
  props: {
    text: {
      type: String,
    },
    className: {
      type: String,
    },
  },
  methods: {
    handleClick() {
      this.$emit(EMITTED_ACTIONS.CLICK);
    },
  },
};
</script>

<style scoped>
.hyp-admin-info {
  cursor: pointer;
  position: relative;
  top: 2px;
}
</style>
